import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ClientList } from 'types/api/clientList';

const clientListApi = createApi({
  reducerPath: 'clientListApi',
  tagTypes: ['clientListTag'],
  baseQuery: fetchBaseQuery({ baseUrl: '/api/client-lists' }),
  endpoints: (build) => ({
    getList: build.query<ResponseList<ClientList>, RequestList>({
      query: (params) => ({ url: '', params }),
    }),
    createFile: build.mutation<ResponseOne<ClientList>, FormData>({
      query: (body) => {
        return {
          url: '',
          method: 'POST',
          body,
        };
      },
    }),
    updateFile: build.mutation<ResponseOne<ClientList>, [string, FormData]>({
      query: ([clientId, body]) => ({
        url: `${clientId}/files`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export default clientListApi;
